import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

import { ChangePasswordFacade, CustomerFacade, NotificationFacade } from '@ridango/components';

import { BaseComponent } from '@ridango/core';
import { take, takeUntil } from 'rxjs/operators';
import { passwordValidator } from '@ridango/core/lib/validators/password.validator';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'rwidget-customer-account-change-password',
    templateUrl: './customer-account-change-password.component.html',
    styleUrls: ['./customer-account-change-password.component.scss']
})
export class CustomerAccountChangePasswordComponent extends BaseComponent implements OnInit, OnDestroy {
    _passwordForm: FormGroup;
    showOldPassword = false;
    showNewPassword = false;
    showNewPasswordRepeat = false;

    @Output() saveSuccess = new EventEmitter<any>();

    constructor(
        private changePasswordFacade: ChangePasswordFacade,
        private customerFacade: CustomerFacade,
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit() {
        this._passwordForm = new FormGroup({
            username: new FormControl('', [Validators.required]),
            password: new FormControl('', [Validators.required]),
            new_password: new FormControl('', passwordValidator),
            new_password_again: new FormControl('', passwordValidator)
        });

        this.changePasswordFacade.getNewPassword();
        this.customerFacade.getCustomerProfile();
        this.customerFacade.profile$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((d) => this._passwordForm.controls['username'].patchValue(d.email));

        this.changePasswordFacade.isSubmitted$.pipe(takeUntil(this.componentDestroyed$)).subscribe((isSubmitted) => {
            if (isSubmitted) {
                this.changePasswordFacade.error$.pipe(take(1)).subscribe((error) => {
                    if (error) {
                        this.handleError(error);
                    } else {
                        this.notification.success(this.translate.instant('LOCAL_CHANGE_PASSWORD_SUCCESS'), {
                            showAfterRouteChange: true
                        });
                        this.saveSuccess.emit();
                    }
                });
            }
        });
    }

    handleError(e: any) {
        if (e.error.error) {
            this.notification.error(this.translate.instant(e.error.error));
        } else {
            this.notification.error(this.translate.instant(e.error));
        }
    }

    submitPassword() {
        if (this._passwordForm.valid) {
            if (
                this._passwordForm.controls['new_password'].value ===
                this._passwordForm.controls['new_password_again'].value
            ) {
                const payload = this._passwordForm.value;
                delete payload['new_password_again'];
                this.changePasswordFacade.setNewPassword(payload);
            } else {
                this.notification.error(this.translate.instant('LOCAL_PASSWORDS_MUST_MATCH'));
            }
        }
    }

    getFirstError(control: AbstractControl, errorCodes: string[]): string {
        return errorCodes.find((errorCode) => control.hasError(errorCode));
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
